import { render, staticRenderFns } from "./ServiceTodayCalling.vue?vue&type=template&id=2770ce6c&scoped=true&"
import script from "./ServiceTodayCalling.vue?vue&type=script&lang=js&"
export * from "./ServiceTodayCalling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2770ce6c",
  null
  
)

export default component.exports